<template>
  <div>
    <add-magazine-modal></add-magazine-modal>
  </div>
</template>

<script>
  import { AlertManager } from '../components/utils/AlertManager'
  import { mapActions } from 'vuex'
  import Spinner from '../components/ui/Spinner'
  import AddMagazineModal from '../components/curriculum/AddMagazineModal'
  import 'jquery-validation'
  import 'select2/dist/js/select2.min.js'
  
  export default {
    name: 'RegisterEditorialCouncil',
    components: {
      Spinner,
      AddMagazineModal,
    },
    data() {
      return {
        saving: false,
        abbreviated_title: '',
        title: '',
        issn: '',
        impact: '',
        type: '',
        group: '',
        typeList: [
          {
            text: 'Seleccione un tipo',
            value: '',
          },
          {
            text: 'CONACYT',
            value: 'CONACYT',
          },
          {
            text: 'JCR CIENTIFICO',
            value: 'JCR CIENTIFICO',
          },
          {
            text: 'JCR SOCIAL',
            value: 'JCR SOCIAL',
          },
          {
            text: 'Otra',
            value: 'Otra',
          },
        ],
        groupList: [
          {
            text: 'Seleccione un grupo',
            value: '',
          },
          {
            text: 'Grupo I',
            value: 'I',
          },
          {
            text: 'Grupo II',
            value: 'II',
          },
          {
            text: 'Grupo III',
            value: 'III',
          },
          {
            text: 'Grupo IV',
            value: 'IV',
          },
          {
            text: 'Grupo V',
            value: 'V',
          },
          {
            text: 'Grupo VI',
            value: 'VI',
          },
          {
            text: 'Grupo VII',
            value: 'VII',
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        reqeuestMagazine: 'magazines/requestMagazine',
      }),

      async addMagazine() {
        this.saving = true
        
        const response = await this.reqeuestMagazine({
          abbreviated_title: this.abbreviated_title,
          title: this.title,
          issn: this.issn,
          impact: this.impact,
          type: this.type,
          group: this.group,
        })
        
        this.saving = false
        
        const { error, status, message } = response
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        this.clearForm()
        AlertManager.success(message)
      },

      clearForm() {
        this.abbreviated_title = ''
        this.title = ''
        this.issn = ''
        this.impact = ''
        this.type = ''
        this.group = ''
      }
    },
    mounted() {
      const vm = this
  
      /**
       * Init Select2 for search magazines
       */
      const searchMagazines = $('.search-magazines')
      
      searchMagazines.select2({
        placeholder: 'Buscar revista...',
        ajax: {
          url: '/api/curriculum/magazines',
          dataType: 'json',
          headers: {
            'Authorization': `Bearer ${window.access_token}`,
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1
            
            const formattedData = $.map(data.data, function(obj) {
              obj.id = obj.id
              return obj
            })
            
            return {
              results: formattedData,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
        templateResult: function(state) {
          if(!state.id) {
            return state.text
          }
          
          let template = $(`
            <div>
              <h6 class="mb-0" style="font-size: 1rem;">
                ${state.text}
              </h6>
              <p class="mb-0" style="font-size: .85rem;">
                ISSN: ${state.issn}
              </p>
              <p class="mb-0" style="font-size: .85rem;">
                Grupo: ${state.group}
              </p>
              <p class="mb-0" style="font-size: .85rem;">
                Factor de impacto: ${state.impact ?? 'No especificado'}
              </p>
            </div>
          `)
          
          return template
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        const $form = $('.form')
  
        $form.validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else if(element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            magazine_id: {
              required: true,
            },
            group: {
              required: true,
            },
            participation_magazine_id: {
              required: true,
            },
            period_since: {
              required: true,
            },
            period_until: {
              required: true,
            },
            type_of_magazine: {
              required: true,
            },
          },
          messages: {
            magazine_id: {
              required: 'Este campo es requerido.',
            },
            group: {
              required: 'Este campo es requerido.',
            },
            participation_magazine_id: {
              required: 'Este campo es requerido.',
            },
            period_since: {
              required: 'Este campo es requerido.',
            },
            period_until: {
              required: 'Este campo es requerido.',
            },
            type_of_magazine: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
  
        $form.removeClass('invisible')

        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()

          history.back()
        })

        /**
         * Show register magazine modal
         */
        $('#register-magazine').click(function () {
          $('#add-magazine-modal').modal('show')
        })
      })
    },
  }
</script>
